import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { TravelInfoComponent } from '@shared/flight-itinerary/components/travel-info/travel-info.component';
import {
  SimpleTravelSummaryComponent
} from '@shared/flight-itinerary/components/simple-travel-summary/simple-travel-summary.component';
import { TravelSummaryComponent } from '@shared/flight-itinerary/components/travel-summary/travel-summary.component';
import { TooltipDirectiveModule } from '@ux/directives/tooltip/tooltip-directive.module';
import { FlightDetailComponent } from '@shared/flight-itinerary/components/flight-detail/flight-detail.component';
import { FlightSegmentConnectionModule } from '@shared/flight-segment-connection/flight-segment-connection.module';
import { LuggageModule } from '@shared/luggage/luggage.module';
import { MobileItineraryComponent } from '@shared/flight-itinerary/components/mobile-itinerary/mobile-itinerary.component';
import {
  MobileItinerayDetailComponent
} from '@shared/flight-itinerary/components/mobile-itinerary-detail/mobile-itinerary-detail.component';
import { BtnLoaderModule } from '@ux/components/btn-loader/btn-loader.module';
import {
  ItineraryPriceDetailComponent
} from '@shared/flight-itinerary/components/itinerary-price-detail/itinerary-price-detail.component';
import { RouteChoiceComponent } from '@shared/flight-itinerary/components/route-choice/route-choice.component';
import {
  RouteChoiceHeaderComponent
} from '@shared/flight-itinerary/components/route-choice-header/route-choice-header.component';
import { TooltipModule } from '@shared/tooltip/tooltip.module';
import {
  MobileItineraryPlaceholderComponent
} from '@shared/flight-itinerary/components/placeholders/mobile-itinerary-placeholder/mobile-itinerary-placeholder.component';
import { ItineraryComponent } from '@shared/flight-itinerary/components/itinerary/itinerary.component';
import { ModalModule } from '@ux/components/modal/modal.module';
import {
  UpsellPlaceholderComponent
} from '@shared/flight-itinerary/components/placeholders/upsell-placeholder/upsell-placeholder.component';
import {
  SortFlightsPlaceholderComponent
} from '@shared/flight-itinerary/components/placeholders/sort-flights-placeholder/sort-flights-placeholder.component';
import { SortFlightsComponent } from '@shared/flight-itinerary/components/sort-flights/sort-flights.component';
import {
  ItineraryPlaceholderComponent
} from '@shared/flight-itinerary/components/placeholders/itinerary-placeholder/itinerary-placeholder.component';
import { FlightResultsFacade } from '@flight-results/flight-results.facade';
import { LastSelectionModule } from '@ux/components/last-selection-header/last-selection-header.module';
import {
  MobileUpsellPlaceholderComponent
} from '@shared/flight-itinerary/components/placeholders/mobile-upsell-placeholder/mobile-upsell-placeholder.component';
import { BookingFacade } from '@booking/booking.facade';
import { PackagesResultFacade } from '@packages/packages-result/store/packages-result.facade';
import {
  ItineraryCabinDetailComponent
} from '@shared/flight-itinerary/components/itinerary-cabin-detail/itinerary-cabin-detail.component';
import { CarouselModule } from '@app/modules/carousel/carousel.module';
import { ImageModule } from '@ux/components/image/image.module';
import { SwipeUpModule } from '@ux/components/swipe-up/swipe-up.module';
import { ItineraryCabinComponent } from '@shared/flight-itinerary/components/itinerary-cabin/itinerary-cabin.component';
import {
  ItineraryCabinDetailDesktopComponent
} from '@shared/flight-itinerary/components/itinerary-cabin-detail-desktop/itinerary-cabin-detail-desktop.component';
import { UpsellModule } from '@upsell/upsell.module';
import {
  MobileItineraryBySectorComponent
} from '@shared/flight-itinerary/components/mobile-itinerary-by-sector/mobile-itinerary-by-sector.component';
import {
  TravelSummaryBySectorComponent
} from '@shared/flight-itinerary/components/travel-summary-by-sector/travel-summary-by-sector.component';
import {
  SelectedItineraryBySectorComponent
} from '@shared/flight-itinerary/components/selected-itinerary-by-sector/selected-itinerary-by-sector.component';
import { MemberRateTagModule } from '@ux/components/member-rate-tag/member-rate-tag.module';
import { PaymentDetailModule } from '@shared/payment-detail/payment-detail.module';
import { ProductTagsModule } from '@shared/product-tags/product-tags.module';
import { BenefitsModule } from '@shared/benefits/benefits.module';
import { ButtonDsComponent } from '@design-system/components/molecules/button/button.component';
import { FixedSurfaceModule } from '@ux/components/fixed-surface/fixed-surface.module';
import { FlightScaleTableDsComponent } from '@design-system/components/organisms/flight-scale-table/flight-scale-table.component';
import { FlightDurationDsComponent } from '@design-system/components/molecules/flight-duration/flight-duration.component';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { BackgroundSurfaceDsComponent } from '@design-system/components/atoms/background-surface/background-surface.component';
import { DividerDsComponent } from '@design-system/components/atoms/divider/divider.component';
import { LoaderRingDsComponent } from '@design-system/components/atoms/loader-ring/loader-ring.component';
import { RadioButtonDsComponent } from '@design-system/components/organisms/radio-button/radio-button.component';
import { HeaderDsComponent } from '@design-system/components/templates/header/header.component';
import { ButtonIconDsComponent } from '@design-system/components/molecules/button-icon/button-icon.component';
import { TabDsComponent } from '@design-system/components/molecules/tab/tab.component';
import { GenericCardDsComponent } from '@design-system/components/templates/generic-card/generic-card.component';
import { TooltipDsDirective } from '@design-system/components/templates/tooltip/directives/tooltip.directive';
import { TooltipDsComponent } from '@design-system/components/templates/tooltip/tooltip.component';

@NgModule({
  declarations: [
    TravelInfoComponent,
    SimpleTravelSummaryComponent,
    TravelSummaryComponent,
    TravelSummaryBySectorComponent,
    FlightDetailComponent,
    MobileItineraryComponent,
    MobileItineraryBySectorComponent,
    MobileItinerayDetailComponent,
    ItineraryPriceDetailComponent,
    RouteChoiceComponent,
    RouteChoiceHeaderComponent,
    MobileItineraryPlaceholderComponent,
    ItineraryComponent,
    UpsellPlaceholderComponent,
    SortFlightsPlaceholderComponent,
    SortFlightsComponent,
    ItineraryPlaceholderComponent,
    MobileUpsellPlaceholderComponent,
    ItineraryCabinDetailComponent,
    ItineraryCabinComponent,
    ItineraryCabinDetailDesktopComponent,
    SelectedItineraryBySectorComponent,
  ],
  imports: [
    CommonModule,
    GlobalPipesModule,
    TranslocoModule,
    TooltipDirectiveModule,
    FlightSegmentConnectionModule,
    LuggageModule,
    BtnLoaderModule,
    TooltipModule,
    ModalModule,
    LastSelectionModule,
    CarouselModule,
    ImageModule,
    SwipeUpModule,
    UpsellModule,
    MemberRateTagModule,
    PaymentDetailModule,
    ProductTagsModule,
    BenefitsModule,
    ButtonDsComponent,
    FixedSurfaceModule,
    FlightScaleTableDsComponent,
    FlightDurationDsComponent,
    IconDsComponent,
    TypographyDsComponent,
    BackgroundSurfaceDsComponent,
    DividerDsComponent,
    LoaderRingDsComponent,
    RadioButtonDsComponent,
    TooltipDsComponent,
    TooltipDsDirective,
    HeaderDsComponent,
    ButtonIconDsComponent,
    TabDsComponent,
    GenericCardDsComponent,
  ],
  exports: [
    TravelInfoComponent,
    SimpleTravelSummaryComponent,
    TravelSummaryComponent,
    TravelSummaryBySectorComponent,
    FlightDetailComponent,
    MobileItineraryComponent,
    MobileItineraryBySectorComponent,
    MobileItinerayDetailComponent,
    ItineraryPriceDetailComponent,
    RouteChoiceComponent,
    RouteChoiceHeaderComponent,
    MobileItineraryPlaceholderComponent,
    ItineraryComponent,
    UpsellPlaceholderComponent,
    SortFlightsPlaceholderComponent,
    SortFlightsComponent,
    ItineraryPlaceholderComponent,
    MobileUpsellPlaceholderComponent,
    SelectedItineraryBySectorComponent,
  ],
  providers: [
    FlightResultsFacade,
    BookingFacade,
    PackagesResultFacade,
  ]
})
export class FlightItineraryModule { }
